import { Component } from 'react';

import _, { flowRight as compose } from 'lodash';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import { withRouter } from 'providers';

import AxlButton from 'AxlMUIComponent/AxlButton';
import AxlModal from 'AxlMUIComponent/AxlModal';
import AxlConfirmation from 'AxlMUIComponent/AxlConfirmation';
import { MESSENGER_TYPE } from '../../../constants/messenger';
import { ASSIGNMENT_STATUS } from '../../../constants/status';
import MessengerProfilePanel from '../../../screens/MessengerScreen/MessengerProfilePanel';
import styles, * as E from './styles';

class ShipmentMessengerTabGroups extends Component {
  render() {
    const cloneProps = { ...this.props };
    delete cloneProps.active;
    delete cloneProps.children;

    const { store } = this.props;
    const { messengerStore } = store;
    const { topicSelected, closing, opening } = messengerStore;

    if (!topicSelected) return null;

    const props = cloneProps;

    const isOpen = topicSelected?.status !== 'CLOSED';

    return (
      <div>
        <ActiveTabs {...props} />
        <div>{this.props.children}</div>
      </div>
    );
  }
}

export default compose(withRouter, inject('store'), observer)(ShipmentMessengerTabGroups);

class ActiveTabsCompose extends Component {
  constructor(props) {
    super(props);
    this.state = {
      solving: false,
      unsolving: false,
      isResolveModalClose: true,
      isUnfollowModalClose: true,
      isFollowModalClose: true,
      isCloseTopicModalClose: true,
      isReopenModalClose: true,
    };
  }

  openTopic = () => {
    const { messengerStore } = this.props.store;
    messengerStore.openTopic();
  };

  closeTopic = () => {
    const { messengerStore } = this.props.store;
    messengerStore.closeTopic();
  };

  push = (url) => {
    if (!url || !this.props.history) return false;

    this.props.history.push(url);
  };

  _handleFollow = (topic) => {
    const { messengerStore } = this.props.store;

    messengerStore.follow((res) => {
      if (res.ok || res.status === 200) {
        messengerStore.externaLloadTopic(topic.id, (response) => {
          if (response.ok || response.status === 200) {
            if (this.props.actionCallback) {
              this.props.actionCallback('SELF_FOLLOW', response.data);
            }
          }
        });
      }
    });
  };

  _handleUnfollow = (topic) => {
    const { messengerStore } = this.props.store;

    messengerStore.unfollow((res) => {
      if (res.ok || res.status === 200) {
        messengerStore.externaLloadTopic(topic.id, (response) => {
          if (response.ok || response.status === 200) {
            if (this.props.actionCallback) {
              this.props.actionCallback('SELF_UNFOLLOW', response.data);
            }
          }
        });
      }
    });
  };

  _handleSolved = (topic) => {
    const { messengerStore } = this.props.store;

    this.setState({ solving: true });

    messengerStore.solve(topic.id || null, (res) => {
      if (res.ok || res.status === 200) {
        this.setState({ solving: false });
        messengerStore.externaLloadTopic(topic.id, (response) => {
          if (response.ok || response.status === 200) {
            if (this.props.actionCallback) {
              this.props.actionCallback('SOLVED', response.data);
            }
          }
        });
      }
    });
  };

  _handleUnsolved = (topic) => {
    const { messengerStore } = this.props.store;

    this.setState({ unsolving: true });

    messengerStore.unsolve(topic.id || null, (res) => {
      if (res.ok || res.status === 200) {
        this.setState({ unsolving: false });
        messengerStore.externaLloadTopic(topic.id, (response) => {
          if (response.ok || response.status === 200) {
            if (this.props.actionCallback) {
              this.props.actionCallback('UNSOLVED', response.data);
            }
          }
        });
      }
    });
  };

  render() {
    const { solving, unsolving } = this.state;
    const { userStore, messengerStore, assignmentStore } = this.props.store;
    const { topicSelected, following, assignmentInfoInTopicSelected } = messengerStore;
    const { selectedAssignment } = assignmentStore;
    const { user } = userStore;
    // Validating
    const isTopicSelected = !!topicSelected;
    const isTopicOpen = isTopicSelected && topicSelected.status !== 'CLOSED';
    const isAssignmentConversation = !!(isTopicSelected && topicSelected.ref_type === MESSENGER_TYPE.ASSIGNMENT_CONVERSATION);
    const isGeneralSupport = !!(isTopicSelected && topicSelected.ref_type === MESSENGER_TYPE.DRIVER_GENERAL_SUPPORT);
    const isAssignment =
      assignmentStore.selectedAssignment?.assignment || messengerStore.assignmentInfoInTopicSelected?.assignment;
    const isCloseTopic = isTopicOpen && isAssignmentConversation;
    const isReOpenTopic = !isTopicOpen && isAssignmentConversation;
    const isDriverActive =
      !!assignmentStore.selectedAssignment?.assignment?.driver_id ||
      !!messengerStore.assignmentInfoInTopicSelected?.driver?.id;
    const isShowFollow = !following && isCloseTopic && topicSelected.follower_ids?.includes(user.id);
    const isShowUnfollow = !following && isCloseTopic && topicSelected.follower_ids && !topicSelected.follower_ids?.includes(user.id);
    const isShowSolved = !solving && isGeneralSupport && user && ['UNSOLVED', 'SOLVING'].includes(topicSelected.situation);
    const isShowUnsolved = !solving && isGeneralSupport && user && ['SOLVED'].includes(topicSelected.situation);
    const isAssignmentActive =
      assignmentInfoInTopicSelected?.assignment?.is_active ||
      assignmentInfoInTopicSelected?.assignment?.status === ASSIGNMENT_STATUS.COMPLETED;
    const isDispatchRoute = !!window.location.href.match(/\/routes/)?.length;
    const isMessengerRoute = !!window.location.href.match(/\/messenger/)?.length;
    // Show is validated
    const isShowAssignmentHistory = isAssignmentConversation && !!isAssignment && isMessengerRoute;
    const isShowShareFiles = isAssignmentConversation || isGeneralSupport;
    const isShowMembers = (isAssignmentConversation || isGeneralSupport) && isTopicOpen;
    const isShowAddUser = isTopicOpen && isAssignmentConversation;
    const isShowMessengerLink = isTopicOpen && isDispatchRoute;
    const isShowDispatchLink = isAssignmentConversation && !!isAssignment && isMessengerRoute;
    const isShowProfilePanel = isMessengerRoute && !this.props.assignmentLoading;
    const isShowAssignmentDetail = isAssignmentConversation && assignmentInfoInTopicSelected?.assignment;
    // Variables
    const userCounter = (isTopicSelected && topicSelected.follower_ids.filter((fid) => !topicSelected.protege_ids.includes(fid)).length) || 0;
    const dispatchLink = !!isAssignment
      ? `/routes` + (isAssignment ? `/${moment(isAssignment.predicted_end_ts).format('YYYY-MM-DD')}/all/${isAssignment.id}` : '')
      : null;
    const messengerLink = `/messenger/${_.get(messengerStore, 'topicSelected.id', '')}`;
    const filesCounter =
      messengerStore.messengers?.length
        ? messengerStore.messengers.reduce((a, { files }) => a + (files?.length || 0), 0)
        : 0;

    return (
      <E.Container>
        <E.InnerScrollable>
          <E.UserContainer>{isShowProfilePanel && <MessengerProfilePanel history={this.props.history} />}</E.UserContainer>
          {isShowAssignmentDetail && (
            <AxlButton
              title={`Assignment Details`}
              compact
              bg={`greyOne`}
              style={{ ...styles.buttonWrap, ...styles.buttonCounter }}
              onClick={() => this.props.onChangePanel('assignmentDetail')}
            >{`Assignment Details`}</AxlButton>
          )}
          {isShowSolved && (
            <AxlModal
              isClose={this.state.isResolveModalClose}
              onRendered={() => this.setState({ isResolveModalClose: false })}
              trigger={
                <AxlButton
                  compact
                  title={`Mark this topic as solved`}
                  bg={`greyOne`}
                  style={{ ...styles.buttonWrap, ...styles.buttonCounter }}
                >{`Resolve`}</AxlButton>
              }
            >
              <AxlConfirmation
                title={`CONFIRMATION`}
                subTitle={`Are you sure you want to resolve this chat?`}
                doText={`YES, resolve this chat`}
                onDo={() => this._handleSolved(topicSelected)}
                closeText={`NO`}
                onClose={() => this.setState({ isResolveModalClose: true })}
              />
            </AxlModal>
          )}
          {isShowUnsolved && (
            <AxlButton
              title={`Mark this topic as Unsolved`}
              compact
              bg={`greyOne`}
              onClick={() => this._handleUnsolved(topicSelected)}
              style={{ ...styles.buttonWrap, ...styles.buttonCounter }}
            >{`Unsolved`}</AxlButton>
          )}
          {isShowFollow && (
            <AxlModal
              isClose={this.state.isUnfollowModalClose}
              onRendered={() => this.setState({ isUnfollowModalClose: false })}
              trigger={
                <AxlButton
                  title={`Unfollow this topic`}
                  compact
                  bg={`greyOne`}
                  style={{ ...styles.buttonWrap, ...styles.buttonCounter }}
                >{`Unfollow`}</AxlButton>
              }
            >
              <AxlConfirmation
                title={`CONFIRMATION`}
                subTitle={`Are you sure to unfollow this chat?`}
                doText={`YES, unfollow this chat`}
                onDo={() => this._handleUnfollow(topicSelected)}
                closeText={`No`}
                onClose={() => this.setState({ isUnfollowModalClose: true })}
              />
            </AxlModal>
          )}
          {isShowUnfollow && (
            <AxlModal
              isClose={this.state.isFollowModalClose}
              onRendered={() => this.setState({ isFollowModalClose: false })}
              trigger={
                <AxlButton
                  title={`Follow this topic`}
                  compact
                  bg={`greyOne`}
                  style={{ ...styles.buttonWrap, ...styles.buttonCounter }}
                >{`Follow`}</AxlButton>
              }
            >
              <AxlConfirmation
                title={`CONFIRMATION`}
                subTitle={`Are you sure to follow this chat?`}
                doText={`YES, follow this chat`}
                onDo={() => this._handleFollow(topicSelected)}
                closeText={`No`}
                onClose={() => this.setState({ isFollowModalClose: true })}
              />
            </AxlModal>
          )}
          {isShowMembers && (
            <AxlButton
              title={`Member list into a topic`}
              source={`/assets/images/svg/member.svg`}
              compact
              bg={`greyOne`}
              style={{ ...styles.buttonWrap, ...styles.buttonCounter }}
              onClick={() => this.props.onChangePanel('flyChat')}
            >
              <E.MemberCount>{userCounter}</E.MemberCount>
            </AxlButton>
          )}
          {/*{isShowAddUser && <AxlButton*/}
          {/*  title={`Add/Remove user into topic`}*/}
          {/*  ico={{className: "fa fa-user-plus"}} compact bg={`greyOne`}*/}
          {/*  style={{...styles.buttonWrap, ...styles.buttonCounter}}*/}
          {/*  onClick={() => this.props.onChangePanel('listUser')}>*/}
          {/*</AxlButton>}*/}
          {/*{isShowAssignmentHistory && <AxlButton*/}
          {/*  title={`Assignment history`}*/}
          {/*  ico={{className: 'fa fa-history'}} compact bg={`greyOne`}*/}
          {/*  style={{...styles.buttonWrap, ...styles.buttonCounter}} onClick={() => this.props.onChangePanel('historyPanel')} />}*/}
          <AxlButton
            title={`Share files`}
            source={`/assets/images/copy.png`}
            compact
            bg={`greyOne`}
            style={{ ...styles.buttonWrap, ...styles.buttonCounter }}
            onClick={() => this.props.onChangePanel('shareFiles')}
          >
            <E.MemberCount>{filesCounter}</E.MemberCount>
          </AxlButton>
          {isCloseTopic && (
            <AxlModal
              isClose={this.state.isCloseTopicModalClose}
              onRendered={() => this.setState({ isCloseTopicModalClose: false })}
              trigger={
                <AxlButton
                  title={`Close topic`}
                  source={`/assets/images/close-chat.png`}
                  compact
                  bg={`greyOne`}
                  style={{ ...styles.buttonWrap, ...styles.buttonCounter }}
                />
              }
            >
              <AxlConfirmation
                title={`CONFIRMATION`}
                subTitle={`Are you sure to close this chat?`}
                doText={`YES, close this chat`}
                onDo={() => messengerStore.closeTopic()}
                closeText={`NO`}
                onClose={() => this.setState({ isCloseTopicModalClose: true })}
              />
            </AxlModal>
          )}
          {isReOpenTopic && (
            <AxlModal
              isClose={this.state.isReopenModalClose}
              onRendered={() => this.setState({ isReopenModalClose: false })}
              trigger={
                <AxlButton
                  title={`Reopen topic`}
                  source={`/assets/images/reopen-chat.png`}
                  compact
                  bg={`greyOne`}
                  style={{ ...styles.buttonWrap, ...styles.buttonCounter }}
                />
              }
            >
              <AxlConfirmation
                title={`CONFIRMATION`}
                subTitle={`Are you sure you want to reopen this chat?`}
                doText={`YES, reopen this chat`}
                onDo={() => messengerStore.openTopic()}
                closeText={`No`}
                onClose={() => this.setState({ isReopenModalClose: true })}
              />
            </AxlModal>
          )}
          {isShowMessengerLink && (
            <AxlButton
              compact
              bg={`greyOne`}
              onClick={() => this.push(messengerLink)}
              style={{ ...styles.buttonWrap, ...styles.buttonCounter }}
            >{`View in Messenger`}</AxlButton>
          )}
          {isShowDispatchLink && (
            <E.ButtonLinkContainer>
              <E.ButtonLink
                compact
                href={dispatchLink}
                target={`_blank`}
                style={{ ...styles.buttonWrap, ...styles.buttonCounter }}
                rel="noreferrer"
              >{`View in Dispatcher`}</E.ButtonLink>
            </E.ButtonLinkContainer>
          )}
        </E.InnerScrollable>
      </E.Container>
    );
  }
}
const ActiveTabs = compose(withRouter, inject('messengerStore', 'userStore', 'assignmentStore'), observer)(ActiveTabsCompose);
